import {Injectable} from '@angular/core';

function _window() : any {
    // return the global native browser window object
    return window;
 }

@Injectable()
export class BrowserUtil {
    isFacebookBrowser(): boolean {
        return navigator.userAgent.includes('FBAV');
    }

    isOnline(): boolean {
        return navigator.onLine;
    }

    scrollToTop(): void {
        window.scrollTo(0, 0);
    }
    get nativeWindow() : any {
        return _window();
     }
}
